import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener, Input, Type, ViewChild } from "@angular/core";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { Datatransfer } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { AccStatusKind, RowState, SystemKind } from "projects/sepidz-web-framework/src/lib/models/enums";
import { FormControlTypes } from "projects/sepidz-web-framework/src/lib/models/form-base-control.model";
import { LookupService, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { MisSetupService } from "projects/sepidz-web-framework/src/lib/services/missetup.service";
import { AccVoucherHeader } from "../../models/accvoucherheader.model";
import { AccVoucherKind } from "../../models/accvoucherkind.model";
import { VoucherInfo } from "../../models/voucherInfo.model";

import { UntypedFormControl } from "@angular/forms";
import { Moment } from "jalali-moment";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { DialogType } from "projects/sepidz-web-framework/src/lib/models/dialog.enum";
import { takeUntil } from "rxjs/operators";

import * as moment from "jalali-moment";
import { ReportKindInfo } from "projects/sepidz-web-framework-data-grid/src/lib/report-kind";
import { ReportCopyComponent } from "projects/sepidz-web-framework-data-grid/src/lib/report-selector/report-copy.component";
import { ReportSelectorComponent } from "projects/sepidz-web-framework-data-grid/src/lib/report-selector/report-selector.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { AccVoucherDetailComponent } from "../accvoucher-detail/accvoucher-detail.component";
import { AccvoucherModalListComponent } from "../accvoucher-modal-list/accvoucher-modal-list.component";

@Component({
  selector: "ngx-accvoucher-form",
  templateUrl: "./accvoucher-form.component.html",
  styleUrls: ["./accvoucher-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccVoucherFormComponent extends BaseFormComponent<AccVoucherHeader> {
  @ViewChild("detail") public detail: AccVoucherDetailComponent;
  inputEditorform: Type<any>;
  reportKinds = ReportKindInfo.reportKinds;
  detailcolumns: form_control[];
  accVoucerherDetailcolumns: form_control[];
  notCloseForm: boolean = false;
  isOkForLoad: boolean = false;
  isNewVoucher: boolean = false;
  selected: boolean = false;
  erroremessage: string;
  isLoadingDate: boolean = false;
  statusKindChanging: boolean = false;
  isLoadingMaxNUmber: boolean = false;
  @Input() isModal: boolean = false;
  confirmLabel: string;
  public columnsOrder: form_control[] = [];
  OtherInfoColumns: form_control[] = [];
  FixNoColumns: form_control[] = [];
  DailyNoColumns: form_control[] = [];
  SubLedgerColumns: form_control[] = [];
  DetailLedger2Columns: form_control[] = [];
  DetailLedger5Columns: form_control[] = [];
  SummeryDebitcolumns: form_control[] = [];
  SummeryCreditcolumns: form_control[] = [];
  accountInf: string = "";
  get currentFiscalYear() {
    return this.accountService?.authService?.currentFiscalYear;
  }
  @HostListener("window:keydown", ["$event"])
  cs(e: KeyboardEvent) {
    if (document.hidden) return;
    if (e.ctrlKey && e.shiftKey && !e.altKey && (e.key.toUpperCase() === "P" || e.key === "ح" || e.key === "\\")) {
      e.preventDefault();
      this.currentReport = "preview";
      this.changeReport("preview");
    }
    if (e.ctrlKey && e.altKey && !e.shiftKey && (e.key.toUpperCase() === "P" || e.key === "ح")) {
      e.preventDefault();
      this.currentReport = "editReport";
      this.changeReport("editReport");
    }
    if (e.ctrlKey && !e.altKey && !e.shiftKey && (e.key.toUpperCase() === "P" || e.key === "ح")) {
      e.preventDefault();
      this.currentReport = "print";
      this.changeReport("print");
    }
    if (e.ctrlKey && (e.key.toUpperCase() === "N" || e.key === "د")) {
      e.preventDefault();
      this.newVoucher();
    }
    if (e.ctrlKey && (e.key.toUpperCase() === "D" || e.key === "ی" || e.key === "ی")) {
      e.preventDefault();
      this.deleteVoucher();
    }
    if (e.ctrlKey && e.shiftKey && (e.key.toUpperCase() === "S" || e.key === "س")) {
      e.preventDefault();
      this.accountConfirm();
    }
    if (e.ctrlKey && e.altKey && (e.key.toUpperCase() === "S" || e.key === "س")) {
      e.preventDefault();
      this.accountWrite();
    }
    if (e.ctrlKey && (e.key.toUpperCase() === "R" || e.key === "ق")) {
      e.preventDefault();
      this.ngOnInit();
    }
  }
  constructor(
    private lookupservice: LookupService,
    __id: FormContainerModel,
    _tabsservice: TabularService,
    protected cd: ChangeDetectorRef,
    private missetup: MisSetupService,
    public selectorService: SelectorService,
    private datatransfer: Datatransfer
  ) {
    super(selectorService, cd);
    if (!this.isModal) {
      this._id = __id;
      this.currentrow = this.datatransfer?.currentrow;
      if (this.datatransfer?.apiName) this.apiName = this.datatransfer?.apiName;
      if (this.datatransfer?.label) this.label = this.datatransfer?.label;
      if (this.datatransfer?.areaName) this.areaName = this.datatransfer?.areaName;
    }
    this.tabsservice = _tabsservice;
    this.currentFiscalYear;
  }

  async ngOnInit() {
    let temp = this.accountService.authService.currentFiscalYear;
    this.statusKindChanging = false;
    if (this.isModal) this._id = undefined;
    if (this.currentrow && this.currentrow["AccVoucherHeaderId"]) this.currentrow.Id = this.currentrow["AccVoucherHeaderId"];
    this.isNewVoucher = false;

    this.missetup.source$.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
      if (x && x.length > 0) this.setDetailColumns();
    });

    this.ReportSelectorForm = ReportSelectorComponent;
    this.ReportCopyForm = ReportCopyComponent;
    this.reportName = "AccountingDocument";
    this.pathPreFix = "ACC";
    this.apiName = "AccVoucherHeader";
    this.areaName = "Accounting";
    this.setDetailColumns();
    this.loadReports();
    this.formGroup = undefined;
    this.isOkForLoad = false;
    this.isClosing = false;
    if (this.currentrow && this.currentrow.Id) {
      this.id = this.currentrow.Id;
      if (this.currentrow.AccVoucherHeaderId) this.id = this.currentrow.AccVoucherHeaderId;
    }
    super.ngOnInit();
    if (this.detail) {
      if (this.isNewRow) this.detail.dataList = [];
      this.detail?.ngOnInit();
    }
  }

  async getVoucherDate() {
    if (this.missetup.getboolean("ACC", "ToDayDate")) {
      this.model.VoucherDate = new Date();
      this.setValue("VoucherDate", this.model.VoucherDate);
      return;
    }
    if (this.currentFiscalYear && !this.isLoadingDate) {
      this.isLoadingDate = true;
      await this.httpCommonService
        .get(`${this.apiName}/GetMaxDate/?FiscalYearId=${this.currentFiscalYear.Id}`)
        .pipe(takeUntil(this.ngUnsubscribe))
        .toPromise()
        .then(
          (data) => {
            if (data) {
              this.isLoadingDate = false;
              this.model.VoucherDate = data as Date;
              this.setMaxCode();
              this.setValue("VoucherDate", this.model.VoucherDate);
            }
          },
          (error) => {
            this.isLoadingDate = false;
          }
        );
    } else
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe(
        async (x) => {
          if (x && !this.isLoadingDate) {
            this.isLoadingDate = true;
            await this.httpCommonService
              .get(`${this.apiName}/GetMaxDate/?FiscalYearId=${x.Id}`)
              .pipe(takeUntil(this.ngUnsubscribe))
              .toPromise()
              .then((data) => {
                if (data) {
                  this.isLoadingDate = false;
                  this.model.VoucherDate = data as Date;
                  this.setValue("VoucherDate", this.model.VoucherDate);
                }
              });
          }
        },
        (error) => {
          this.isLoadingDate = false;
        }
      );
  }
  async setMaxCode() {
    if (!this.isNewRow && this.model.Id > 0) return;
    if (!this.currentFiscalYear) {
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe(async (x) => {
        if (x) {
          if (!this.model.VoucherDate && this.formGroup) this.model.VoucherDate = this.formGroup.controls["VoucherDate"].value;

          this.isLoadingMaxNUmber = true;
          const voucherInfo = new VoucherInfo();
          voucherInfo.VoucherDate = this.model.VoucherDate;
          voucherInfo.FiscalYearId = x.Id;
          await this.httpCommonService
            .create(`${this.apiName}/GetMaxNumber`, voucherInfo)
            .pipe(takeUntil(this.ngUnsubscribe))
            .toPromise()
            .then(
              (data) => {
                if (data) {
                  this.isLoadingMaxNUmber = false;
                  this.model["VoucherNo"] = data["VoucherNo"];
                  this.model["FixNo"] = data["FixNo"];
                  this.model["DailyNo"] = data["DailyNo"];
                  this.setValue("VoucherNo", this.model["VoucherNo"]);
                  this.setValue("FixNo", this.model["FixNo"]);
                  this.setValue("DailyNo", this.model["DailyNo"]);

                  this.setdefault();
                  //this.setFormGroup(this.model);
                }
              },
              (error) => {
                this.isLoadingMaxNUmber = false;
              }
            );
        }
      });
    } else if (!this.isLoadingMaxNUmber) {
      if (!this.model.VoucherDate && this.formGroup) this.model.VoucherDate = this.formGroup.controls["VoucherDate"].value;
      this.isLoadingMaxNUmber = true;
      const voucherInfo = new VoucherInfo();
      voucherInfo.VoucherDate = this.model.VoucherDate ?? new Date();
      voucherInfo.FiscalYearId = this.currentFiscalYear.Id;
      await this.httpCommonService
        .create(`${this.apiName}/GetMaxNumber`, voucherInfo)
        .pipe(takeUntil(this.ngUnsubscribe))
        .toPromise()
        .then(
          (data) => {
            if (data) {
              this.isLoadingMaxNUmber = false;
              this.model["VoucherNo"] = data["VoucherNo"];
              this.model["FixNo"] = data["FixNo"];
              this.model["DailyNo"] = data["DailyNo"];
              this.setValue("VoucherNo", this.model["VoucherNo"]);
              this.setValue("FixNo", this.model["FixNo"]);
              this.setValue("DailyNo", this.model["DailyNo"]);
              this.setdefault();
            }
          },
          (error) => {
            this.isLoadingMaxNUmber = false;
          }
        );
    }
  }
  setdefault() {
    this.setDisabledValue().then();
    this.setAccVoucherKind().then();
    this.label = this.translate("ClientApp.BackOffice.ACC.AccVoucher.AccVoucherHeader") + `(${this.model.VoucherNo ?? 0})`;
    if (this._id && this.model.VoucherNo) {
      this.tabsservice.setTabTitle(this._id.metadata.id, this.getFormTitle());
    }
    if (!this.model.VoucherDate) {
      this.getVoucherDate().then();
    }
    if (!this.model?.AccVoucherDetails) this.model.AccVoucherDetails = [];
    if (!this.model.SystemKindId) {
      this.lookupservice
        .getLookupbyCode("GNR", "SystemKind", SystemKind.ACC)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          this.model.SystemKindId = x.Id;
          this.model.SystemKindCode = x.Code;
          this.model.SystemKindTitle = x.Title;
          this.setValue("SystemKindId", x.Id);
          this.setValue("SystemKindCode", x.Code);
          this.setValue("SystemKindTitle", x.Title);
        });
    }
    if (!this.model.AccVoucherKindId && this.selectorService.getDataList("AccVoucherKindId")) {
      let vk = this.selectorService.getDataList("AccVoucherKindId").find((x) => x.Code === 1);
      if (vk) {
        this.model.AccVoucherKindId = vk.Id;
        this.model.AccVoucherKindCode = vk.Code;
        this.model.AccVoucherKindTitle = vk.Title;
        this.setValue("AccVoucherKindId", vk.Id);
        this.setValue("AccVoucherKindCode", vk.Code);
        this.setValue("AccVoucherKindTitle", vk.Title);
      }
    }
    if (!this.model.StatusKindId) {
      this.lookupservice
        .getLookupbyCode("ACC", "StatusKind", AccStatusKind.Inspection)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          this.model.StatusKindId = x.Id;
          this.model.StatusKindCode = x.Code;
          this.model.StatusKindTitle = x.Title;
          this.setValue("StatusKindId", x.Id);
          this.setValue("StatusKindCode", x.Code);
          this.setValue("StatusKindTitle", x.Title);
          this.confirmLabel = "بررسی سند";
        });
    }
    if (this.model.StatusKindCode >= AccStatusKind.Confirm) this.confirmLabel = "لغو بررسی";
    else this.confirmLabel = "بررسی سند";
    if (!this.model.FiscalYearId && this.currentFiscalYear) {
      this.model.FiscalYearId = this.currentFiscalYear.Id;
      this.model.Year = this.currentFiscalYear.Year;
    } else if (!this.model.FiscalYearId) {
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        this.model.FiscalYearId = x.Id;
        this.model.Year = x.Year;
        this.setValue("FiscalYearId", x.Id);
        this.setValue("Year", x.Year);
      });
    }
    if (!this.model.BranchId) {
      this.model.BranchId = 0;
      this.setValue("BranchId", this.model.BranchId);
    }
    if (!this.model.FiscalMonth && this.model.VoucherDate) {
      this.model.FiscalMonth = this.getjMonth(this.model.VoucherDate);
      this.setValue("FiscalMonth", this.model.FiscalMonth);
    }
    this.setColumnAttribute();
    if (this.model && this.model?.AccVoucherDetails && this.model?.AccVoucherDetails?.length > 0 && this.detail) {
      this.detail.dataList = this.model?.AccVoucherDetails;
    }
    if (this.detail && this.isNewRow === false && this.model.AccVoucherDetails.length > 0) this.detail?.cancelHandler();
    if (this.detail) {
      this.detail.dataList = this.model?.AccVoucherDetails ?? [];
      this.detail.ngOnInit();
    }

    setTimeout(() => {
      if (this.detail) {
        this.detail.dataList.forEach((x) => {
          if (x.Id > 0) x.State = RowState.NoChange;
        });
      }
      this.setAllUnTouched();
    }, 100);
  }
  isNoValidForEdit() {
    let StatusKindCode: number = AccStatusKind.Confirm;
    return (
      !this.isNewRow &&
      this.model &&
      (this.model?.SystemKindCode > SystemKind.ACC ||
        (this.model?.AccVoucherKindCode > 1 && this.model?.AccVoucherKindCode < 7) ||
        this.model?.StatusKindCode >= StatusKindCode)
    );
  }

  setColumnAttribute() {
    if (!this.accVoucerherDetailcolumns || this.accVoucerherDetailcolumns.length <= 0)
      this.accVoucerherDetailcolumns = this.getDetailControlModels("AccVoucherDetails");
    super.setColumnAttribute();
    if (this.isNoValidForEdit()) {
      this.orignalColumns.forEach((x) => {
        x.disabled = true;
        if (this.formGroup && this.formGroup.get(x.name)) {
          if (x.disabled) this.formGroup.get(x.name).disable();
          else this.formGroup.get(x.name).enable();
        }
      });
    }
    if (this.formGroup) this.formGroup.updateValueAndValidity();
    this.OtherInfoColumns = this.getcolumns("OtherInfo");
    this.FixNoColumns = this.getcolumns("FixNo");
    this.DailyNoColumns = this.getcolumns("DailyNo");
    this.SubLedgerColumns = this.getcolumns("SubLedger");
    this.DetailLedger2Columns = this.getcolumns("DetailLedger2");
    this.DetailLedger5Columns = this.getcolumns("DetailLedger5");
    this.SummeryDebitcolumns = this.getcolumns("SummeryDebit");
    this.SummeryCreditcolumns = this.getcolumns("SummeryCredit");

    this.columns.forEach((x) => ((x.isFloat = null), (x.userClass = null)));
    this.cd.markForCheck();
  }
  getjMonth(date: Date) {
    let m: Moment = moment(date.toString()).locale("fa");
    return Number(m.format("jMM"));
  }
  settemp() {
    console.log(this.model);
  }
  async setAccVoucherKind() {
    await this.httpCommonService
      .get("AccVoucherKind/ReadAccVoucherKindLookUp")
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (data: AccVoucherKind[]) => {
          let vk = data.filter((x) => x.Code === 1 || !x.IsOperating);
          this.selectorService.setDataList("AccVoucherKindId", vk);
          let _vk = vk.find((x) => x.Code === 1);
          if (_vk) {
            this.model.AccVoucherKindId = _vk.Id;
            this.model.AccVoucherKindTitle = _vk.Title;
            this.model.AccVoucherKindCode = _vk.Code;
            this.setValue("AccVoucherKindId", _vk.Id);
            this.setValue("AccVoucherKindCode", _vk.Code);
            this.setValue("AccVoucherKindTitle", _vk.Title);
          }
        },
        (error) => {}
      );
  }

  onChanged($event) {
    if (this.isNewRow || !this.model) this.setdefault();
    if ($event && $event.apiName === "AccVoucherKind/ReadAccVoucherKindLookUp") {
      this.model.AccVoucherKindTitle = $event.data.Title;
      this.model.AccVoucherKindCode = $event.data.Code;
      if (this.model?.AccVoucherKindCode > 1 && this.model?.AccVoucherKindCode < 7) {
        if (this.selectorService.getDataList("AccVoucherKindId") && this.formGroup.controls["AccVoucherKindId"]) {
          let vk = this.selectorService.getDataList("AccVoucherKindId").find((x) => x.Code === 1);
          if (vk) {
            this.model.AccVoucherKindId = vk.Id;
            this.model.AccVoucherKindCode = vk.Code;
            this.model.AccVoucherKindTitle = vk.Title;
            this.formGroup.controls["AccVoucherKindId"].setValue(vk.Id);
          }
        } else this.formGroup.controls["AccVoucherKindId"].setValue(undefined);
        this.setdefault();
        this.sts.showDialog("نوع سند از نوع سیستمی قابل انتخاب نیست.", "انتخاب نوع سند");
      }
    }
  }
  onValueChange($event) {
    this.model.VoucherDate = this.formGroup.controls["VoucherDate"].value;
    //this.setMaxCode();
  }
  async setDisabledValue() {
    await this.httpCommonService
      .getList("AccVoucherKind/ReadAccVoucherKindLookUp")
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (x: AccVoucherKind[]) => {
          if (x) {
            let temp = x.filter((x) => x.Code >= 2 && x.Code <= 6).map((x) => x.Id);
            this.selectorService.setDisabledValue("AccVoucherKindId", temp);
            this.cd.markForCheck();
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }
  onValueChangeByApiName($event) {
    if (this.isNewRow) this.setdefault();
    if ($event instanceof AccVoucherKind) {
      this.model.AccVoucherKindTitle = ($event as AccVoucherKind).Title;
      this.model.AccVoucherKindCode = ($event as AccVoucherKind).Code;
    }
  }
  get detailLedgerLevel(): number {
    return this.missetup.getnumber("ACC", "DLLEVEL");
  }
  get copyHeaderTitleToDetailTitle(): boolean {
    return this.missetup.getboolean("ACC", "CopyHeaderTitleToDetailTitle");
  }

  get headerTitleToDetailTitle(): string {
    if (this.copyHeaderTitleToDetailTitle && this.formGroup && this.formGroup.controls["Comment"]) return this.formGroup.controls["Comment"].value;

    return undefined;
  }

  setDetailColumns() {
    const level = this.detailLedgerLevel;
    this.detailcolumns = [];
    this.detailcolumns.push(<form_control>{
      label: "گروه حساب",
      controlType: FormControlTypes.textbox,
      modelName: "GroupLedgerTitle",
      disabled: true,
      name: "GroupLedgerTitle",
      order: 0,
      areaName: "SubLedger",
      textType: "text",
      withComma: true,
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.detailcolumns.push(<form_control>{
      label: "حساب کل",
      controlType: FormControlTypes.textbox,
      modelName: "GeneralLedgerTitle",
      disabled: true,
      name: "GeneralLedgerTitle",
      order: 1,
      areaName: "SubLedger",
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.detailcolumns.push(<form_control>{
      label: "حساب معین",
      controlType: FormControlTypes.textbox,
      modelName: "SubLedgerTitle",
      disabled: true,
      name: "SubLedgerTitle",
      order: 2,
      areaName: "SubLedger",
      textType: "text",
      formVisible: level >= 1,
      listVisible: true,
      required: false,
    });
    this.detailcolumns.push(<form_control>{
      label: "حساب تفصیلی 1",
      controlType: FormControlTypes.textbox,
      modelName: "DetailLedger1Title",
      disabled: true,
      name: "DetailLedger1Title",
      order: 3,
      areaName: "DetailLedger2",
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.detailcolumns.push(<form_control>{
      label: "حساب تفصیلی 2",
      controlType: FormControlTypes.textbox,
      modelName: "DetailLedger2Title",
      disabled: true,
      name: "DetailLedger2Title",
      order: 4,
      areaName: "DetailLedger2",
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.detailcolumns.push(<form_control>{
      label: "حساب تفصیلی 3",
      controlType: FormControlTypes.textbox,
      modelName: "DetailLedger3Title",
      disabled: true,
      name: "DetailLedger3Title",
      order: 5,
      areaName: "DetailLedger2",
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.detailcolumns.push(<form_control>{
      label: "حساب تفصیلی 4",
      controlType: FormControlTypes.textbox,
      modelName: "DetailLedger4Title",
      disabled: true,
      name: "DetailLedger4Title",
      order: 6,
      areaName: "DetailLedger5",
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.detailcolumns.push(<form_control>{
      label: "حساب تفصیلی 5",
      controlType: FormControlTypes.textbox,
      modelName: "DetailLedger5Title",
      disabled: true,
      name: "DetailLedger5Title",
      order: 7,
      areaName: "DetailLedger5",
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.detailcolumns.push(<form_control>{
      label: "حساب تفصیلی 6",
      controlType: FormControlTypes.textbox,
      modelName: "DetailLedger6Title",
      disabled: true,
      name: "DetailLedger6Title",
      order: 8,
      areaName: "DetailLedger5",
      textType: "text",
      formVisible: true,
      listVisible: true,
      required: false,
    });
    this.detailcolumns.push(<form_control>{
      label: "حساب تفصیلی 7",
      controlType: FormControlTypes.textbox,
      modelName: "DetailLedger7Title",
      disabled: true,
      name: "DetailLedger7Title",
      order: 9,
      areaName: "DetailLedger6",
      textType: "text",
      formVisible: level >= 2,
      listVisible: true,
      required: false,
    });
    this.detailcolumns.push(<form_control>{
      label: "مانده در خط",
      controlType: FormControlTypes.textbox,
      modelName: "RowRemain",
      disabled: true,
      name: "RowRemain",
      order: 11,
      areaName: "SummeryDebit",
      textType: "number",
      withComma: true,
      formVisible: true,
      required: false,
    });
    this.detailcolumns.push(<form_control>{
      label: "جمع بدهکار",
      controlType: FormControlTypes.textbox,
      modelName: "DebitTotal",
      disabled: true,
      name: "DebitTotal",
      order: 10,
      areaName: "SummeryDebit",
      textType: "number",
      withComma: true,
      formVisible: true,
      required: false,
    });
    this.detailcolumns.push(<form_control>{
      label: "جمع بستانکار",
      controlType: FormControlTypes.textbox,
      modelName: "CreditTotal",
      disabled: true,
      name: "CreditTotal",
      order: 12,
      areaName: "SummeryCredit",
      textType: "number",
      withComma: true,
      formVisible: true,
      required: false,
    });
    this.detailcolumns.push(<form_control>{
      label: "اختلاف سند",
      controlType: FormControlTypes.textbox,
      modelName: "DocumentDifference",
      disabled: true,
      name: "DocumentDifference",
      order: 13,
      areaName: "SummeryCredit",
      textType: "number",
      withComma: true,
      formVisible: true,
      required: false,
    });
    this.detailcolumns.forEach((x) => (x.userClass = "select-sm"));
  }
  getcolumns(key: string) {
    let col: form_control[] = [];
    if (key === "SubLedger" || key === "DetailLedger2" || key === "DetailLedger5" || key.includes("Summery"))
      col = this.detailcolumns.filter((f) => f.areaName === key && f.formVisible);
    else col = this.orignalColumns.filter((f) => f.areaName === key && f.formVisible);
    return col.sort((a, b) => a.order - b.order);
  }
  onValueChanges($event) {
    this.selectorService.onSubmited.next(true);
    const arrowIcon = "<i class='icon-keyboard_arrow_left-o'></i>";
    if (this.detail && this.detail?.dataList) this.model.AccVoucherDetails = this.detail?.dataList;
    if ($event && !$event.data) {
      this.setSummery($event);
    }
    if ($event && $event["SubLedgerId"]) {
      this.setValue("GroupLedgerTitle", $event["GroupLedgerTitle"]);
      this.setValue("GeneralLedgerTitle", $event["GeneralLedgerTitle"]);
      this.setValue("SubLedgerTitle", $event["SubLedgerTitle"]);
    } else if (!$event.columnName) {
      this.setValue("GroupLedgerTitle", "");
      this.setValue("GeneralLedgerTitle", "");
      this.setValue("SubLedgerTitle", "");
    }
    if ($event && $event.columnName === "SubLedgerId") {
      this.setValue("GroupLedgerTitle", $event.data.GroupLedgerTitle);
      this.setValue("GeneralLedgerTitle", $event.data.GeneralLedgerTitle);
      this.setValue("SubLedgerTitle", $event.data.Title);
    } else {
      if ($event && $event.columnName === "DetailLedgerId") this.setValue("DetailLedger1Title", $event.data.Title);
      else this.setValue("DetailLedger1Title", "");
      if ($event && $event["DetailLedgerId"]) this.setValue("DetailLedger1Title", $event["DetailLedgerTitle"]);
      else this.setValue("DetailLedger1Title", "");
      if ($event && $event.columnName === "DetailLedger2Id") this.setValue("DetailLedger2Title", $event.data.Title);
      else this.setValue("DetailLedger2Title", "");
      if ($event && $event["DetailLedger2Id"]) this.setValue("DetailLedger2Title", $event["DetailLedger2Title"]);
      else this.setValue("DetailLedger2Title", "");
      if ($event && $event.columnName === "DetailLedger3Id") this.setValue("DetailLedger3Title", $event.data.Title);
      else this.setValue("DetailLedger3Title", "");
      if ($event && $event["DetailLedger3Id"]) this.setValue("DetailLedger3Title", $event["DetailLedger3Title"]);
      else this.setValue("DetailLedger3Title", "");
      if ($event && $event.columnName === "DetailLedger4Id") this.setValue("DetailLedger4Title", $event.data.Title);
      else this.setValue("DetailLedger4Title", "");
      if ($event && $event["DetailLedger4Id"]) this.setValue("DetailLedger4Title", $event["DetailLedger4Title"]);
      else this.setValue("DetailLedger4Title", "");
      if ($event && $event.columnName === "DetailLedger5Id") this.setValue("DetailLedger5Title", $event.data.Title);
      if ($event && $event["DetailLedger5Id"]) this.setValue("DetailLedger5Title", $event["DetailLedger5Title"]);
      else this.setValue("DetailLedger5Title", "");
      if ($event && $event.columnName === "DetailLedger6Id") this.setValue("DetailLedger6Title", $event.data.Title);
      else this.setValue("DetailLedger6Title", "");
      if ($event && $event["DetailLedger6Id"]) this.setValue("DetailLedger6Title", $event["DetailLedger6Title"]);
      else this.setValue("DetailLedger6Title", "");
      if ($event && $event.columnName === "DetailLedger7Id") this.setValue("DetailLedger7Title", $event.data.Title);
      else this.setValue("DetailLedger7Title", "");
      if ($event && $event["DetailLedger7Id"]) this.setValue("DetailLedger7Title", $event["DetailLedger7Title"]);
      else this.setValue("DetailLedger7Title", "");
      this.accountInf = `${this.formGroup.get("GroupLedgerTitle").value} ${arrowIcon} ${
        this.formGroup.get("GeneralLedgerTitle").value
      } ${arrowIcon} ${this.formGroup.get("SubLedgerTitle").value}`;
      if (this.detailLedgerLevel >= 1 && this.formGroup.get("DetailLedger1Title")?.value)
        this.accountInf = `${this.accountInf} ${arrowIcon} ${this.formGroup.get("DetailLedger1Title")?.value}`;
      if (this.detailLedgerLevel >= 2 && this.formGroup.get("DetailLedger2Title")?.value)
        this.accountInf = `${this.accountInf} ${arrowIcon} ${this.formGroup.get("DetailLedger2Title")?.value}`;
      if (this.detailLedgerLevel >= 3 && this.formGroup.get("DetailLedger3Title")?.value)
        this.accountInf = `${this.accountInf} ${arrowIcon} ${this.formGroup.get("DetailLedger3Title")?.value}`;
      if (this.detailLedgerLevel >= 4 && this.formGroup.get("DetailLedger4Title")?.value)
        this.accountInf = `${this.accountInf} ${arrowIcon} ${this.formGroup.get("DetailLedger4Title")?.value}`;
      this.cd.markForCheck();
    }
    this.cd.markForCheck();
    this.isValid();
  }

  isValid() {
    let flag: boolean = true;
    this.erroremessage = undefined;
    if (this.isNoValidForEdit() && this.model.StatusKindCode > AccStatusKind.Inspection && this.statusKindChanging !== true) {
      this.erroremessage = `این سند قابل ویرایش نیست.`;
      flag = false;
      return flag;
    }
    if (!this.formGroup.controls["FiscalYearId"].value) {
      if (!this.formGroup.controls["FiscalYearId"].value && !this.accountService?.authService?.currentFiscalYear) {
        this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
          if (x) this.setValue("FiscalYearId", x.Id);
        });
        this.erroremessage = `سال مالی انتخاب نشده است.`;
        flag = false;
      } else if (this.accountService.authService.currentFiscalYear)
        this.setValue("FiscalYearId", this.accountService.authService.currentFiscalYear.Id);
      return flag;
    }
    if (
      new Date(this.formGroup.controls["VoucherDate"].value).setHours(0, 0, 0, 0) <
        new Date(this.accountService.authService.currentFiscalYear.StartDate).setHours(0, 0, 0, 0) ||
      new Date(this.formGroup.controls["VoucherDate"].value).setHours(0, 0, 0, 0) >
        new Date(this.accountService.authService.currentFiscalYear.EndDate).setHours(0, 0, 0, 0)
    ) {
      this.erroremessage = "تاریخ سند باید در محدوده سال مالی باشد.";
      return false;
    }
    if (
      flag &&
      this.model.StatusKindCode > AccStatusKind.Write &&
      this.model &&
      this.model?.AccVoucherDetails &&
      this.model?.AccVoucherDetails?.getSumWithKey("Debit") !== this.model?.AccVoucherDetails?.getSumWithKey("Credit")
    ) {
      this.erroremessage = "جمع بدهکار و بستانکار اختلاف دارد.";

      flag = false;
    }
    if (
      flag &&
      this.model.AccVoucherDetails &&
      this.model?.AccVoucherDetails?.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached)?.length > 0
    ) {
      if (!this.formGroup?.valid) {
        let list = this.setFormGroupErrors();
        console.log(list);
      }
      flag = this.formGroup?.valid;
    }
    if (flag && this.model?.AccVoucherDetails?.filter((x) => x.State != RowState.Delete && x.State != RowState.Detached)?.length <= 0) {
      this.erroremessage = "برای سند هیچ قلمی وارد نشده است.";
      flag = false;
    }
    if (flag) {
      flag = !this.erroremessage;
    }
    return flag;
  }

  beforupdate() {
    if (this.detail) {
      if (this.detail.formGroup && this.detail?.formGroup?.valid) this.detail.saveCurrent();
      else this.detail.cancelHandler();
    }
    if (this.isValid()) {
      if (this.model?.AccVoucherDetails && this.model?.AccVoucherDetails?.length > 0) {
        this.model.AccVoucherDetails = this.model?.AccVoucherDetails?.filter((x) => x.State !== RowState.Detached && x.Id >= 0);
        if (!this.formGroup.controls["AccVoucherDetails"])
          this.formGroup.addControl("AccVoucherDetails", new UntypedFormControl(this.model?.AccVoucherDetails));
        else this.formGroup.controls["AccVoucherDetails"].setValue(this.model?.AccVoucherDetails);
        this.formGroup.updateValueAndValidity();
      } else this.erroremessage = "برای سند هیچ قلمی وارد نشده است.";
    }
  }
  addControl() {
    this.isOkForLoad = false;
    this.detailcolumns.forEach((x) => {
      let value: any = 0;
      if (x.textType === "number") value = 0;
      else value = "";
      if (this.formGroup) {
        if (!this.formGroup.controls[x.name]) this.formGroup.addControl(x.name, new UntypedFormControl({ value: value, disabled: true }));
        else this.formGroup.controls[x.name].setValue(value);
      }
    });
    if (!this.isNewRow && this.model && this.model?.AccVoucherDetails && this.model?.AccVoucherDetails?.length > 0) {
      this.onValueChanges(this.model?.AccVoucherDetails[0]);
    }

    this.isOkForLoad =
      this.isNewRow ||
      (this.model !== undefined && this.model?.AccVoucherDetails !== undefined && this.model?.AccVoucherDetails?.length > 0) ||
      (this.detail !== undefined && this.detail?.dataList !== undefined && this.detail?.dataList?.length > 0);
    this.cd.markForCheck();
  }
  setSummery(entity: any) {
    if (!entity && (!this.model?.AccVoucherDetails || this.model?.AccVoucherDetails?.length <= 0)) return;
    if (!entity) entity = this.model?.AccVoucherDetails[this.model?.AccVoucherDetails?.length - 1];
    this.detailcolumns.forEach((x) => {
      if (entity[x.name]) this.setValue(x.name, entity[x.name]);
    });
    if (entity) {
      let rws = this.model?.AccVoucherDetails?.filter(
        (x) => x.RowNumber <= entity.RowNumber && x.State != RowState.Delete && x.State != RowState.Detached
      );
      if (rws) this.setValue("RowRemain", rws?.getSumWithKey("Debit") - rws?.getSumWithKey("Credit"));
      this.setValue("TotalPrice", this.model?.AccVoucherDetails?.getSumWithKey("Debit"));
      this.setValue("DebitTotal", this.model?.AccVoucherDetails?.getSumWithKey("Debit"));
      this.setValue("CreditTotal", this.model?.AccVoucherDetails?.getSumWithKey("Credit"));
      this.setValue(
        "DocumentDifference",
        this.model?.AccVoucherDetails?.getSumWithKey("Debit") - this.model?.AccVoucherDetails?.getSumWithKey("Credit")
      );
    }

    this.cd.markForCheck();
  }
  closeForm(flag: boolean = false) {
    if (flag && !this.isNewVoucher) {
      if (this._id?.metadata?.id) this.tabsservice.tabItemOnCanClosing.next(this._id?.metadata?.id);
      if (this.isNewVoucher) {
        this.model = undefined;
        this.currentrow = undefined;
        this.ngOnInit();
      } else this.close();
    }
    if (this.isNewVoucher && flag) {
      this.selectorService.submitted$.next(false);
      this.model = undefined;
      this.currentrow = undefined;
      this.ngOnInit();
    }
    this.isClosing = false;
  }
  canDeactivate() {
    if (
      !(
        (this.formGroup && this.formGroup.dirty && this.formGroup.touched) ||
        (this.model?.AccVoucherDetails?.length > 0 &&
          this.model?.AccVoucherDetails?.some((x) => x.State === RowState.New || x.State === RowState.Modify))
      )
    )
      return true;
    this.sts.showDialog(
      "شما اطلاعات ذخیره نشده دارید! در صورت خروج اطلاعات از دست خواهد رفت.",
      "هشدار",
      DialogType.confirm,
      () => this.closeForm(true),
      () => this.closeForm(false)
    );
    return this.notCloseForm;
  }
  accountInspection() {
    if (
      this.model &&
      this.model?.AccVoucherDetails &&
      this.model?.AccVoucherDetails?.getSumWithKey("Debit") !== this.model?.AccVoucherDetails?.getSumWithKey("Credit")
    ) {
      this.erroremessage = "جمع بدهکار و بستانکار اختلاف دارد.";
      return;
    }

    if (!this.detail?.formGroup?.valid && this.detail.dataList.length <= 0) {
      this.sts.showDialog(`اطلاعات وارده صحیح نیست.`, "خطا", DialogType.alert);
      return;
    }
    if (this.formGroup.controls["StatusKindCode"].value <= AccStatusKind.Write) {
      this.lookupservice
        .getLookupbyCode("ACC", "StatusKind", AccStatusKind.Inspection)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          if (x) {
            this.model.StatusKindId = x.Id;
            this.model.StatusKindCode = x.Code;
            this.model.StatusKindTitle = x.Title;
            this.setValue("StatusKindId", x.Id);
            this.setValue("StatusKindCode", x.Code);
            this.setValue("StatusKindTitle", x.Title);
            this.confirmLabel = "بررسی سند";
            if (this.detail) {
              if (this.detail.formGroup && this.detail?.formGroup?.valid) this.detail.saveCurrent();
              else this.detail.cancelHandler();
            }
            this.save();
          }
        });
    }
  }
  isCloseable() {
    this.selectorService.submitted$.next(false);
    this.formGroup?.markAsUntouched();
    return false;
  }
  accountWrite() {
    if (!this.detail?.formGroup?.valid && this.detail.dataList.length <= 0) {
      this.sts.showDialog(`اطلاعات وارده صحیح نیست.`, "خطا", DialogType.alert);
      return;
    }
    if (this.formGroup.controls["StatusKindCode"].value <= AccStatusKind.Inspection) {
      this.lookupservice
        .getLookupbyCode("ACC", "StatusKind", AccStatusKind.Write)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          if (x) {
            this.model.StatusKindId = x.Id;
            this.model.StatusKindCode = x.Code;
            this.model.StatusKindTitle = x.Title;
            this.setValue("StatusKindId", x.Id);
            this.setValue("StatusKindCode", x.Code);
            this.setValue("StatusKindTitle", x.Title);
            this.confirmLabel = "بررسی سند";
            if (this.detail) this.detail.saveCurrent();
            this.save();
          }
        });
    }
  }
  accountConfirm() {
    if (!this.detail?.formGroup?.valid && this.detail.dataList.length <= 0) {
      this.sts.showDialog(`اطلاعات وارده صحیح نیست.`, "خطا", DialogType.alert);
      return;
    }
    if (
      (this.formGroup.controls["StatusKindCode"].value === AccStatusKind.Confirm || this.isValid()) &&
      (this.formGroup.controls["StatusKindCode"].value === AccStatusKind.Inspection ||
        this.formGroup.controls["StatusKindCode"].value === AccStatusKind.Confirm)
    ) {
      this.lookupservice
        .getLookupbyCode("ACC", "StatusKind", this.model.StatusKindCode === AccStatusKind.Confirm ? AccStatusKind.Inspection : AccStatusKind.Confirm)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          if (x) {
            this.model.StatusKindId = x.Id;
            this.model.StatusKindCode = x.Code;
            this.model.StatusKindTitle = x.Title;
            this.setValue("StatusKindId", x.Id);
            this.setValue("StatusKindCode", x.Code);
            this.setValue("StatusKindTitle", x.Title);
            if (this.model.StatusKindCode === AccStatusKind.Confirm) this.confirmLabel = "لغو بررسی";
            else this.confirmLabel = "بررسی سند";
            if (this.detail) this.detail.saveCurrent();
            this.statusKindChanging = true;
            this.save();
          }
        });
    }
  }
  async delete_Voucher() {
    this.sts.showToast("primary", "", "در حال حذف...");
    await this.httpCommonService
      .delete(this.apiName, this.model.Id)
      .pipe(takeUntil(this.ngUnsubscribe))
      .toPromise()
      .then(
        (results) => {
          this.sts.showToast("success", "", "اطلاعات با موفیت حذف شد.");
          this.model = undefined;
          this.currentrow = undefined;
          this.ngOnInit();
        },
        (error) => {
          this.sts.showDialog(`${this.label}: ${Utilities.getHttpResponseMessage(error)}`, "خطا در حذف اطلاعات");
        }
      );
  }
  deleteVoucher() {
    this.sts.showDialog(`آیا از حذف سند اطمینان دارید؟`, "حذف سند", DialogType.confirm, () => this.delete_Voucher());
  }
  newVoucher() {
    this.isNewVoucher = true;
    if (this.canDeactivate()) {
      this.isClosing = false;
      this.model = undefined;
      this.currentrow = undefined;
      this.ngOnInit();
      setTimeout(() => this.detail?.ngOnInit(), 100);
    }
  }

  public cancel() {
    if (!this.isClosing && this.canDeactivate()) {
      this.showValidationErrors = false;
      this.sts.showToast("primary", "انصراف", "عملیات توسط کاربر متوقف شد.");
      this.close();
    }
  }
  setSelected() {
    this.selected = !this.selected;
  }
  gridheight() {
    return this.selected ? 45 : 57;
  }
  loadVoucherList() {
    this.inputEditorform = AccvoucherModalListComponent;
    this.dialogService
      .open(
        this.inputEditorform,
        {
          label: this.label,
        },
        {
          autoFocus: true,
          closeOnClickOutside: false,
          closeOnEscape: false,
        }
      )
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (model) => {
        if (model) {
          if (this.detail) this.detail.cancelHandler();
          this.currentrow = model;
          this.id = this.currentrow.Id;
          await this.ngOnInit();
          if (this.detail) setTimeout(() => this.detail.cancelHandler(), 100);
        }
      });
  }
  ngOnDestroy() {
    super.ngOnDestroy();
    this.selectorService.setDataList("AccVoucherKindId", undefined);
    this.inputEditorform = undefined;
    this.reportKinds = undefined;
    this.detailcolumns = undefined;
    this.accVoucerherDetailcolumns = undefined;
    this.columnsOrder = undefined;
    this.OtherInfoColumns = undefined;
    this.FixNoColumns = undefined;
    this.DailyNoColumns = undefined;
    this.SubLedgerColumns = undefined;
    this.DetailLedger2Columns = undefined;
    this.DetailLedger5Columns = undefined;
    this.SummeryDebitcolumns = undefined;
    this.SummeryCreditcolumns = undefined;
  }
}
